import React from 'react';
import { ArrowUpRight, CheckCircle2 } from 'lucide-react';

const offerings = [
  'Spiritual Life Coaches, Hypnotists, Metaphysical Healers, Psychics, and Herbalists',
  'Book a single session or a multi-session program with the same practitioner',
  'Every session built around your specific situation, tailored to you personally',
  'Meet over Zoom, on your schedule, as soon as today',
];

const BookYourSession = () => (
  <section id="private-help" className="scroll-mt-24 bg-[#f7f1ff] py-20 text-purple-950 sm:py-28">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:px-8">
      <div>
        <p className="mb-5 text-xs font-semibold uppercase tracking-[0.35em] text-purple-600">Private 1 on 1 Help</p>
        <h2 className="font-title text-4xl font-bold text-purple-900 sm:text-5xl">
          You already know the thing that&apos;s been sitting heavy.
        </h2>
        <div className="mt-7 space-y-5 text-lg leading-8 text-purple-800/75">
          <p>
            The relationship that needs clarity. The decision you keep circling. The pattern you&apos;re ready to finally shift. Our elite practitioners bring real, advanced gifts to work with you directly, one on one, whether you need a single session to get clear or a full program to work through it completely.
          </p>
        </div>
        <a
          href="https://twnhub.online/services"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-9 inline-flex items-center gap-2 rounded-lg bg-purple-900 px-6 py-3 text-sm font-semibold uppercase tracking-[0.14em] text-white transition hover:bg-purple-800"
        >
          Book Your Session Now <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>

      <div className="rounded-3xl bg-white p-7 shadow-xl sm:p-10">
        <p className="mb-6 text-xs font-semibold uppercase tracking-[0.3em] text-purple-600">Built around you</p>
        <ul className="space-y-5">
          {offerings.map((item) => (
            <li key={item} className="flex gap-4 text-base leading-7 text-purple-900/80">
              <CheckCircle2 className="mt-1 h-5 w-5 shrink-0 text-purple-600" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
        <blockquote className="mt-9 border-t border-purple-100 pt-7 font-title text-2xl italic leading-9 text-purple-800">
          “Continuing my journey with Aquiera has been such a joy. I look forward to each session, as I feel myself unlocking/accessing more of me. I&apos;ve stopped abandoning myself for people who echo old patterns.”
          <footer className="mt-4 font-body text-xs not-italic uppercase tracking-[0.14em] text-purple-500">
            — Bianca Mayes, Private 1 on 1 Session
          </footer>
        </blockquote>
      </div>
    </div>
  </section>
);

export default BookYourSession;